module.exports = __webpack_public_path__ + "static/media/next-icon-empty-wine-glass-o.28d4c400.svg";